import React from "react";
import DashboardOptionButtons from "./DashboardOptionButtons";
import { Widget } from "system/widget/Widget";
import Topbar from "components/layout/Topbar";
import { Box } from "@mui/system";
import AvatarMenu from "./AvatarMenu";
import HelpMenu from "./HelpMenu";
import DashboardPageChangeArrows from "./DashboardPageChangeArrows";

export interface DashboardTopbarProps {
  currentPageId: string;
  isInLayoutMode: boolean;
  setIsInLayoutMode: (isInLayoutMode: boolean) => void;
  onAddWidget: (type:string, widgetOptions?:any, startingLayouts?:any, openSettingsOnAdd?: boolean) => void;
  onClearWidgets: () => void;
  handleUpdatePageName: (name: string) => void;
  exportRef: any;
  isOpen?: boolean;
  widgets: Array<Widget>

  onUpdateWidget: (widgetId: string, updatedWidgetInfo: any, resetPage?: boolean) => Promise<any>;
  onRefreshWidgets: () => void;
}

export default function DashboardTopbar(props: DashboardTopbarProps): JSX.Element {
  return (
  <Topbar>
    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
      <Box sx={{flex: 1, display: "flex", justifyContent: "center"}}>
        <DashboardPageChangeArrows currentPageId={props.currentPageId} handleUpdatePageName={props.handleUpdatePageName} />
      </Box>
      <DashboardOptionButtons
        onAddWidget = {props.onAddWidget}
        isInLayoutMode = {props.isInLayoutMode}
        setIsInLayoutMode = {props.setIsInLayoutMode}
        onClearWidgets = {props.onClearWidgets}
        imageExportRef = {props.exportRef.current}
        onRefreshWidgets = {props.onRefreshWidgets}
        onUpdateWidget={props.onUpdateWidget}
        widgets = {props.widgets} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <HelpMenu />
        <AvatarMenu />
      </Box>
    </Box>
  </Topbar>
  );
}